import { nanoid } from 'nanoid';

export const updaterAddNewPost = (points = []) => {
  const newPoints = [...points];

  newPoints.push({
    id: nanoid(),
    title: 'Point',
    description: 'description',
  });

  return newPoints;
};

export const updaterEditTitle = (points = [], action) => {
  const updateIndex = points.findIndex((a) => a.id === action.id);

  if (updateIndex < 0) {
    return points;
  }

  const newPoints = [...points];

  newPoints[updateIndex].title = action.value;

  return newPoints;
};

export const updaterEditDescription = (points = [], action) => {
  const updateIndex = points.findIndex((a) => a.id === action.id);

  if (updateIndex < 0) {
    return points;
  }

  const newPoints = [...points];

  newPoints[updateIndex].description = action.value;

  return newPoints;
};

export const updaterPointDelete = (points = [], action) => {
  const newPoints = points.filter((a) => a.id !== action.id);

  return newPoints;
};
